import {
  clearTimeouts,
  engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";

const timeouts = [];

const main = (props) => {
    const timeouts = [];
    const { id, format, templateName, data } = props;

    const timeline = anime.timeline();

    //   const templateDuration = getTemplateDurationOveride({
    //     apiSetup: props?.apiSetup,
    //     tournamentId: props?.data?.event?.competitionId,
    //     fallback:
    //       _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
    //     templateName,
    //     event: data?.event
    //   });
    const templateDuration = 10;
    $(`#${id} .ant-progress-bg`).css("width", "100%");
    $(`#${id} .ant-progress-bg`).css(
        "transition-duration",
        `${templateDuration}s`,
    );

    anime({
        targets: [`#${id} .left-block-side`],
        rotateY: ["-50deg", 0],
        easing: "easeInOutQuad",
        duration: 1000,
    })

    anime({
        targets: [`#${id} .left-block-shadow`],
        width: ["92px", "1px"],
        easing: "easeInOutQuad",
        duration: 1000,
    })

    anime({
        targets: [`#${id} .player-name`],
        opacity: [0, 1],
        translateX: [100, 0],
        easing: "easeInOutQuad",
        duration: 1000,
    })

    anime({
        targets: [`#${id} .item-goal .item-type`],
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 500,
        delay: 400
    })
    anime({
        targets: [`#${id} .item-goal .item-content`],
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 500,
        delay: 400
    })

    anime({
        targets: [`#${id} .item-assist .item-type`],
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 500,
        delay: 600
    })
    anime({
        targets: [`#${id} .item-assist .item-content`],
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 500,
        delay: 600
    })

    anime({
        targets: [`#${id} .item-duel .item-type`],
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 500,
        delay: 800
    })
    anime({
        targets: [`#${id} .item-duel .item-content`],
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 500,
        delay: 800
    })

    return {
        timeline: [],
        timeouts,
    };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
    const { timeouts } = animationReturn;
    clearTimeouts(timeouts);
};

export default main;
